import {defineStore} from 'pinia';
import * as amplitude from '@amplitude/analytics-browser';

export const useTitle = defineStore('title', {
  state: () => ({pTitle: undefined}),
  getters: {
    titleStore: (state) => state.pTitle,
  },
  actions: {
    setTitle(_title, t) {
      if (this.pTitle !== _title) {
        const eventProperties = {
          title: t(_title),
        };
        amplitude.track('Page viewed', eventProperties);
      }
      this.pTitle = _title;
    },
  },
});
